import SliderGate from "./components/SliderGate";

function App() {
  return <SliderGate />;
}

export default App;
